import React, { Component } from "react";

import {
  Button,
  Row,
  Form,
  Col,
  Table,
  Card,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import { toast } from "react-toastify";
import configData from "../config.json";
import LoadingOverlay from "./LoadingOverlay";
export default class Responsejson extends Component {
  constructor(props) {
    super(props);
    const jsonData = sessionStorage.getItem("responsedata");
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      jsonData: jsonData ? JSON.parse(jsonData) : null,
      formattedJsonData: jsonData
        ? JSON.stringify(JSON.parse(jsonData), null, 2)
        : "",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("requestId"),
      responseId: sessionStorage.getItem("responseId"),
      integId: sessionStorage.getItem("integrationlibrary_Id"),
      errors: {},
      filteredData: null,

      tables: [],
      columns: [],
      columnsone: [],
      rcolumns: [],
      columnsWT: [],
      sendingHeader: [],
      // jsonData: "",
      headerData: {
        jsonkey: "",
        tableName: "",
        columnName: "",
        sampleValue: "",
        currentStep: 1,
      },
      defaultDistdefaultDist: {
        id: 0,
        rows: [],
      },
      dynamicTables: [],
      currentPage: 1,
      // isEditing: false,
      itemsPerPage: 10,

      //***state
    };
  }
  handleclick = (e) => {
    window.location.href = "./requestjson";
  };
  handleclickIL = (e) => {
    window.location.href = "./integration_library";
  };

  handleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;

    try {
      const parsedData = JSON.parse(fieldValue); // Parse the entered JSON
      this.setState({
        jsonData: parsedData,
        formattedJsonData: JSON.stringify(parsedData, null, 2), // Format it as a pretty JSON string
      });
    } catch (error) {
      console.error("Invalid JSON format:", error);
      this.setState({ formattedJsonData: fieldValue }); // If it's invalid JSON, keep raw input
    }
  };

  addTable = () => {
    const newId = this.state.dynamicTables.length + 1;
    this.setState((prevState) => ({
      dynamicTables: [
        ...prevState.dynamicTables,
        {
          id: newId,
          tableName: "",
          rows: [],
        },
      ],
      headerData: {
        jsonkey: "",
        tableName: "",
        columnName: "",
        sampleValue: "",
      },
    }));
  };
  fixLooseJson = (input) => {
    // Make sure input is a string
    if (typeof input !== "string") {
      // If input is an object, convert it to a string
      if (typeof input === "object" && input !== null) {
        input = JSON.stringify(input);
      } else {
        // For other non-string values, convert to string or return empty string
        input = String(input || "");
      }
    }

    // Now that we're sure input is a string, we can safely use replace
    // Add quotes around unquoted keys
    return input.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
  };
  deleteTable = (id) => {
    this.setState((prevState) => ({
      dynamicTables: prevState.dynamicTables.filter((table) => table.id !== id),
    }));
  };
  handleEditInputChangeHeader(index, field, value) {
    const updatedHeader = [...this.state.sendingHeader];
    updatedHeader[index][field] = value;
    this.getColumns(value, "rcolumns");
    this.setState({ sendingHeader: updatedHeader });
  }

  handleRemoveSpecificRowHeader = (tableId, rowId) => {
    console.log("Deleting row with ID:", rowId, "from Table ID:", tableId);
    this.setState((prevState) => ({
      dynamicTables: prevState.dynamicTables.map((table) =>
        table.id === tableId
          ? { ...table, rows: table.rows.filter((row) => row.id !== rowId) }
          : table
      ),
    }));
  };

  handleEditTableRowHeader(index) {
    this.setState({ editingIndex: index });
  }

  addSendhrRow = (tableId, e) => {
    e.preventDefault();

    this.setState((prevState) => {
      const selectedJsonKey = prevState.headerData.jsonkey;
      const selectedSampleValue = prevState.headerData.sampleValue;
      const selectedColumnName = prevState.headerData.columnName;
      const selectedTableName = prevState.dynamicTables.find(
        (t) => t.id === tableId
      )?.tableName;

      if (
        !selectedJsonKey ||
        !selectedSampleValue ||
        !selectedColumnName ||
        !selectedTableName
      ) {
        alert("Please select all required fields.");
        return prevState;
      }

      // Get the current number of rows in this table and increment index
      const currentTable = prevState.dynamicTables.find(
        (t) => t.id === tableId
      );
      const rowIndex = currentTable?.rows.length + 1 || 1; // Incrementing index

      // New row to add in UI with an increasing index
      const newRow = {
        id: rowIndex, // Incrementing ID instead of timestamp
        jsonKey: selectedJsonKey,
        tableName: selectedTableName,
        columnName: selectedColumnName,
        value: selectedSampleValue,
      };

      // Find if table already exists in sendingHeader
      let tableIndex = prevState.sendingHeader.findIndex(
        (t) => t.table_name === selectedTableName
      );
      let updatedSendingHeader = [...prevState.sendingHeader];

      if (tableIndex !== -1) {
        // Check if the same column already exists to avoid duplicates
        let existingRowIndex = updatedSendingHeader[
          tableIndex
        ].columns.findIndex(
          (col) =>
            col.key === selectedJsonKey &&
            col.column_name === selectedColumnName
        );

        if (existingRowIndex === -1) {
          // If the row doesn't exist, add it
          updatedSendingHeader[tableIndex].columns.push({
            key: selectedJsonKey,
            column_name: selectedColumnName,
            sample_value: selectedSampleValue,
          });
        } else {
          console.warn("Duplicate row detected! Skipping...");
        }
      } else {
        // If table does not exist, create a new entry
        updatedSendingHeader.push({
          table_name: selectedTableName,
          columns: [
            {
              key: selectedJsonKey,
              column_name: selectedColumnName,
              sample_value: selectedSampleValue,
            },
          ],
        });
      }

      // Update state
      return {
        dynamicTables: prevState.dynamicTables.map((table) =>
          table.id === tableId
            ? { ...table, rows: [...table.rows, newRow] }
            : table
        ),
        sendingHeader: updatedSendingHeader,
        headerData: {
          jsonkey: "",
          tableName: selectedTableName,
          columnName: "",
          sampleValue: "",
        },
      };
    });
  };

  keyvalidatehr() {
    const { currentStep, headerData } = this.state;
    let formIsValid = true;
    if (!headerData["jsonkey"]) {
      formIsValid = false;
      toast.info("*Enter Header Key.");
    } else if (!headerData["tableName"]) {
      formIsValid = false;
      toast.info("*Select Header Table Name.");
    } else if (!headerData["columnName"]) {
      formIsValid = false;
      toast.info("*Select Header Column Name.");
    } else if (!headerData["sampleValue"]) {
      formIsValid = false;
      toast.info("*Enter Header Sample value.");
    } else {
      // If all fields are filled, proceed to the next step
      this.setState({ currentStep: currentStep + 1 });
    }
    return formIsValid;
  }

  inputSHrChange = (e) => {
    const { name, value } = e.target;
    let sampleValue = this.state.headerData.sampleValue;

    if (name === "jsonkey") {
      try {
        // Get the data object safely
        let dataObj;
        if (
          typeof this.state.jsonData === "object" &&
          this.state.jsonData !== null
        ) {
          dataObj = this.state.jsonData;
        } else if (typeof this.state.jsonData === "string") {
          const fixedJson = this.fixLooseJson(this.state.jsonData);
          dataObj = JSON.parse(fixedJson);
        } else {
          dataObj = {};
        }

        // Get the value for the selected key
        const selectedValue = dataObj[value];

        // Handle different value types appropriately
        if (typeof selectedValue === "object" && selectedValue !== null) {
          sampleValue = JSON.stringify(selectedValue);
        } else if (selectedValue !== undefined) {
          sampleValue = String(selectedValue);
        } else {
          sampleValue = "";
        }
      } catch (err) {
        console.error("Error processing JSON in inputSHrChange:", err);
        sampleValue = "";
      }
    } else if (name === "sampleValue") {
      sampleValue = value;
    }

    this.setState((prevState) => ({
      headerData: {
        ...prevState.headerData,
        [name]: value,
        sampleValue,
      },
    }));
  };
  inputtableSHrChange = (e, tableId) => {
    e.preventDefault();
    const fieldValue = e.target.value;

    this.setState(
      (prevState) => ({
        dynamicTables: prevState.dynamicTables.map((table) =>
          table.id === tableId ? { ...table, tableName: fieldValue } : table
        ),
      }),
      () => {
        this.getColumns(fieldValue, "columns"); // Fetch columns for the selected table
      }
    );
  };

  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "masters/gettables", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ tables: data.tables });
        }
      });
  };
  getColumns = (tableName, rcolumn) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ [rcolumn]: data.columns });
        }
      });
  };
  // offcanvas Open

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:
        toast.info(msg);
    }
  };
  Handledowloadcsv = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("responseId", this.state.responseId);
    fetch(configData.api_url + "C_Integrationlibrary/downloadResponseJson", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          const csvContent = `${configData.api_url}${data.filePath}`;
          const link = document.createElement("a");
          link.setAttribute("href", csvContent);
          link.setAttribute("download", `responsejson.xlsx`); // Custom file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };
  ResponsejsonfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("responseId", this.state.responseId);

    fetch(configData.api_url + "C_Integrationlibrary/retriveResJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.data) {
          try {
            // Handle the API response data structure
            let extractedData;

            // Check if data.data is an array
            if (Array.isArray(data.data) && data.data.length > 0) {
              // Use the first object in the array
              extractedData = data.data[0];
            } else {
              // If it's not an array, use it directly
              extractedData = data.data;
            }

            // Ensure extractedData is an object
            if (typeof extractedData !== "object" || extractedData === null) {
              extractedData = {};
            }
            const flattened = this.flattenJson(extractedData);

            this.setState({
              data: Object.entries(flattened).map(([key, value], index) => ({
                id: index + 1,
                jsonKey: key,
                value: String(value ?? ""),
              })),
              formattedJsonData: JSON.stringify(extractedData, null, 2),
              jsonData: extractedData,
              flattenedJson: flattened, // ✅ new state value
            });
          } catch (error) {
            console.error("Error processing response data:", error);
            toast.error("Error processing response data");
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching response JSON:", error);
        toast.error("Error fetching response data");
      });
  };

  mergeTables = (dataArray) => {
    const merged = {};

    dataArray.forEach((tableObj) => {
      if (tableObj.table_name) {
        if (!merged[tableObj.table_name]) {
          merged[tableObj.table_name] = {
            table_name: tableObj.table_name,
            columns: [],
          };
        }
        // Merge all columns into the correct table
        merged[tableObj.table_name].columns.push(...tableObj.columns);
      }
    });

    return merged;
  };
  ResponsejsonsubmitHandler = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("requestId", this.state.requestId);
    formData.append("responseId", this.state.responseId);
    // Merge the `sendingHeader` array before submitting
    const mergedTables = this.mergeTables(this.state.sendingHeader);
    var payload = {};
    console.log("mergedTables:", mergedTables);
    // fetch(configData.api_url + "C_Responsejsonmapping/ad
    payload["tables"] = mergedTables;
    console.log("Payload to be sent:", JSON.stringify(payload, null, 2));
    formData.append("jsonData", JSON.stringify(payload, null, 2));
    console.log("formData:", JSON.stringify(payload));
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Responsejsonmapping/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          window.location.href = "./integrationlibrary";
          this.setState({ integId: "", jsonData: "" });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Error submitting JSON data:", error);
      
        this.setState({ loading: false });});
  };

  ResponsejsonupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("jsonData", JSON.stringify(this.state.sendingHeader));
    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Responsejson/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ResponsejsonfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.ResponsejsonfetchHandler();
    this.getTables();

    const jsonData = sessionStorage.getItem("data");

    try {
      const parsedData = jsonData ? JSON.parse(jsonData) : {};
      this.setState({ jsonData: parsedData });
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    } //***componentDidMount
  }

  handleintegIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ integId: fieldValue });
  };
  handlerequestIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ requestId: fieldValue });
  };

  handlexChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ x: fieldValue });
  };

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  flattenJson(obj, parentKey = "") {
    const result = {};

    for (let key in obj) {
      if (!obj.hasOwnProperty(key)) continue;

      const value = obj[key];
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (value && typeof value === "object" && !Array.isArray(value)) {
        const nested = this.flattenJson(value, fullKey);
        Object.assign(result, nested);
      } else if (Array.isArray(value)) {
        result[fullKey] = JSON.stringify(value);
      } else {
        result[fullKey] = value;
      }
    }

    return result;
  }

  renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
  render() {
    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row>
          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Integration Library")}
            >
              <Card className="nav-card">
                <span className="bi bi-boxes nav-icon"></span>
                <p className="nav-label" onClick={this.handleclickIL}>
                  Integration Library
                </p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Request JSON")}
            >
              <Card
                className="nav-card "
                onClick={() => this.setState({ step: 2 })}
              >
                <span className="bi bi-journal-album nav-icon"></span>
                <p className="nav-label " onClick={this.handleclick}>
                  Request JSON
                </p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Response JSON Mapping")}
            >
              <Card
                className="nav-card active-step"
                onClick={() => this.setState({ step: 3 })}
              >
                <span className="bi bi-table nav-icon"></span>
                <p className="nav-label">Response JSON Mapping</p>
              </Card>
            </OverlayTrigger>
          </Col>
        </Row>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline

                  dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Response JSON Mapping
                      </h3>
                    </div>
                    <Col>
                      <Row>
                        <Form>
                          <Row>
                            <Col lg="6" md="6">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Integration Id
                              </Form.Label>

                              <Form.Control
                                type="number"
                                disabled
                                onChange={this.handleintegIdChange}
                                className="form-control"
                                name="integId"
                                value={this.state.integId}
                                required="required"
                                placeholder="Enter Integ Id"
                              />
                            </Col>
                            <Col lg="6" md="6">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Request ID
                              </Form.Label>

                              <Form.Control
                                disabled
                                type="number"
                                onChange={this.handlerequestIdChange}
                                className="form-control"
                                name="requestId"
                                value={this.state.requestId}
                                required="required"
                                placeholder="Enter Request ID"
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row className="divstyle">
                            <Col>
                              <Form.Group>
                                <Form.Label>JSON Data Response</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  dis
                                  rows="10"
                                  disabled
                                  cols="50"
                                  value={this.state.formattedJsonData}
                                  //value={this.state.jsonData}
                                  onChange={this.handleChange}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <br />
                        </Form>
                        <Col>
                          <p>
                            Spliting JSON In To Table By Adding Tables and
                            Columns
                          </p>
                          <Button
                            variant="primary"
                            className="bi bi-plus"
                            onClick={this.addTable}
                          >
                            Add Table
                          </Button>
                        </Col>
                        {this.state.dynamicTables.map((table, index) => (
                          <div key={table.id}>
                            <h3>Table {table.id}</h3>
                            <Col>
                              <Button
                                variant="warning"
                                onClick={() => this.deleteTable(table.id)}
                                className="bi bi-trash"
                              >
                                delete Table
                              </Button>
                            </Col>
                            <Row>
                              <Col>
                                <Table
                                  className="table table-bordered table-hover"
                                  id="tab_logic"
                                >
                                  <thead>
                                    <tr>
                                      <th className="text-center">S.NO</th>
                                      <th className="text-center">KEY</th>
                                      <th className="text-center">
                                        Table Name
                                      </th>
                                      <th className="text-center">
                                        Column Name
                                      </th>
                                      <th className="text-center">Sample</th>
                                      <th className="text-center">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {table.rows.map((row) => (
                                      <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{row.jsonKey}</td>

                                        <td>{table.tableName}</td>
                                        <td>{row.columnName}</td>
                                        <td>{row.value}</td>

                                        <td>
                                          <button
                                            variant="danger"
                                            className="bi bi-trash-fill btn btn-danger"
                                            onClick={() =>
                                              this.handleRemoveSpecificRowHeader(
                                                table.id,
                                                row.id
                                              )
                                            }
                                          ></button>
                                        </td>
                                      </tr>
                                    ))}
                                    <tr>
                                      <td>---</td>
                                      <td>
                                        <Form.Select
                                          name="jsonkey"
                                          value={this.state.headerData.jsonkey}
                                          onChange={this.inputSHrChange}
                                        >
                                          <option defaultValue>
                                            Select Key
                                          </option>
                                          {(() => {
                                            try {
                                              // Safely get the keys from jsonData
                                              let dataObj;
                                              if (
                                                typeof this.state.jsonData ===
                                                  "object" &&
                                                this.state.jsonData !== null
                                              ) {
                                                dataObj = this.state.jsonData;
                                              } else if (
                                                typeof this.state.jsonData ===
                                                "string"
                                              ) {
                                                dataObj = JSON.parse(
                                                  this.fixLooseJson(
                                                    this.state.jsonData
                                                  )
                                                );
                                              } else {
                                                dataObj = {};
                                              }

                                              return Object.keys(
                                                this.state.flattenedJson || {}
                                              ).map((key, index) => (
                                                <option key={index} value={key}>
                                                  {key}
                                                </option>
                                              ));
                                            } catch (error) {
                                              console.error(
                                                "Error parsing JSON keys:",
                                                error
                                              );
                                              return null;
                                            }
                                          })()}
                                        </Form.Select>
                                      </td>
                                      <td>
                                        <Form.Control
                                          as="select"
                                          className="form-select"
                                          name="tableName"
                                          // value={
                                          //   this.state.headerData.tableName
                                          // }
                                          value={table.tableName || ""}
                                          onChange={(e) =>
                                            this.inputtableSHrChange(
                                              e,
                                              table.id
                                            )
                                          }
                                          disabled={table.tableName}
                                        >
                                          <option defaultValue>
                                            Select Table
                                          </option>
                                          {this.state.tables.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </Form.Control>
                                      </td>
                                      <td>
                                        <Form.Control
                                          as="select"
                                          className="form-select "
                                          name="columnName"
                                          value={
                                            this.state.headerData.columnName
                                          }
                                          onChange={(e) =>
                                            this.inputSHrChange(e)
                                          }
                                        >
                                          <option defaultValue>
                                            Select Column
                                          </option>
                                          {this.state.columns.map(
                                            (api, index, idx) => (
                                              <option key={index} value={api}>
                                                {api}
                                              </option>
                                            )
                                          )}
                                        </Form.Control>
                                      </td>
                                      <td>
                                        <Form.Select
                                          name="sampleValue"
                                          value={
                                            this.state.headerData.sampleValue
                                          }
                                          onChange={this.inputSHrChange}
                                        >
                                          <option defaultValue>
                                            Select Value
                                          </option>
                                          {(() => {
                                            try {
                                              // Safely get the values from jsonData
                                              let dataObj;
                                              if (
                                                typeof this.state.jsonData ===
                                                  "object" &&
                                                this.state.jsonData !== null
                                              ) {
                                                dataObj = this.state.jsonData;
                                              } else if (
                                                typeof this.state.jsonData ===
                                                "string"
                                              ) {
                                                dataObj = JSON.parse(
                                                  this.fixLooseJson(
                                                    this.state.jsonData
                                                  )
                                                );
                                              } else {
                                                dataObj = {};
                                              }

                                              return Object.entries(
                                                this.state.flattenedJson || {}
                                              ).map(([key, value], idx) => {
                                                // Check if the value is an object or array
                                                const displayValue =
                                                  typeof value === "object"
                                                    ? JSON.stringify(value)
                                                    : String(value);

                                                // Convert to a displayable string

                                                // Skip rendering objects directly (or handle them as needed)
                                                return (
                                                  <option
                                                    key={idx}
                                                    value={displayValue}
                                                  >
                                                    {displayValue}
                                                  </option>
                                                );
                                              });
                                            } catch (error) {
                                              console.error(
                                                "Error parsing JSON values:",
                                                error
                                              );
                                              return null;
                                            }
                                          })()}
                                        </Form.Select>
                                      </td>
                                      <td>
                                        <Button
                                          type="button"
                                          variant="success"
                                          className="bi bi-plus"
                                          onClick={(e) =>
                                            this.addSendhrRow(table.id, e)
                                          }
                                        ></Button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </Row>

                      <Row>
                        <Col
                          className="d-flex justify-content-end"
                          style={{ marginRight: "50px" }}
                        >
                          <Button
                            className="button"
                            variant="success"
                            onClick={this.ResponsejsonsubmitHandler}
                            style={{
                              marginTop: "20px",
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            className="button bi bi-arrow-down"
                            variant="success"
                            onClick={this.Handledowloadcsv}
                            style={{
                              marginTop: "20px",
                              marginLeft: "20px",
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
